'use client';

import type { ChoiceType } from '~/model/ChoiceType';
import type { SubQuestionType } from '~/model/SubQuestionType';
import { roundToNDecimal } from '~/utils/utils';

export const GridResult = ({
  resultId,
  resultData,
  answerChoices,
  subQuestions,
}: GridResultPropsType) => {
  const defaultColors = [
    '#004d99',
    '#0073E6',
    '#4DA6FF',
    '#B3D9FF',
    '#D5D6D6',
    '#B6B6B9',
    '#6A6B6D',
    '#262628',
  ];
  const generateRandomColor = () => {
    return `#${Math.floor(Math.random() * 256 ** 3)
      .toString(16)
      .padStart(6, '0')}`;
  };
  const answersRepartition
    = resultData && resultData.length > 0 && resultData[0].answers_repartition;
  const choices
    = answersRepartition
      && answersRepartition.length > 0
      && answersRepartition.map((a, i) => {
        const color: string = defaultColors[i]
          ? defaultColors[i]
          : generateRandomColor();
        const matchingChoice
          = answerChoices?.length > 0
            && answerChoices.find(q => q['@id'] === a['@id']);
        const uri = matchingChoice?.['@id'];
        const title = matchingChoice?.title;
        return { uri, title, color };
      });
  return (
    <>
      <div className="grid-result__header">
        {choices?.length > 0
          && choices.map((choice, i) => {
            return (
              <div
                className="grid-result__choice"
                key={`choice${resultId}-${i}`}
                data-testid="choice-result"
              >
                <span
                  className="grid-result__dot"
                  style={{ backgroundColor: `${choice.color}` }}
                />
                <span className="grid-result__label">{choice.title}</span>
              </div>
            );
          })}
      </div>
      <div data-testid="Grid">
        {resultData?.length > 0
          && resultData.map((subject, index) => {
            const subquestion
              = subQuestions?.length > 0
                && subQuestions.find(sq => sq['@id'] === subject['@id']).title;
            return (
              <div
                className="grid-result__subquestion"
                key={`Grid-${resultId}-${index}`}
                data-cy="GridResult"
              >
                <div className="grid-result__subquestion__label">
                  {subquestion}
                </div>
                <div className="grid-result__subquestion__values">
                  <div className="grid-result__ratio">
                    {subject.answers_repartition
                      && subject.answers_repartition.length > 0
                      && subject.answers_repartition.map((choice, id) => {
                        const colorChoices = choices.find(
                          c => c.uri === choice['@id'],
                        );
                        return (
                          <span
                            key={`subquestion${resultId}${id}`}
                            className="grid-result__percentage"
                            style={{
                              width: `${choice.percentage}%`,
                              backgroundColor: `${
                                colorChoices && colorChoices.color
                              }`,
                            }}
                            data-testid="percentage-result"
                            title={`${roundToNDecimal(choice.percentage)}%`}
                          >
                            {choice.percentage > 5
                              ? `${roundToNDecimal(choice.percentage)}%`
                              : ''}
                          </span>
                        );
                      })}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};

export interface GridResultPropsType {
  resultId: number;
  resultData: Data[];
  answerChoices: ChoiceType[];
  subQuestions: SubQuestionType[];
}

interface Data {
  answers_repartition: AnswersRepartitionType[];
  subquestion: string;
  '@id': string;
}

interface AnswersRepartitionType {
  percentage: number;
  choice: string;
  '@id': string;
}
